import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import BaseLayout from 'components/layouts';
import lazyPage from 'utils/lazyPage';

// 페이지는 라우트 단위로 청크를 나눈다. 정적으로 import 하면 메인 번들에 합쳐지므로
// pages/* 는 반드시 lazyPage(() => import(...)) 로만 불러온다.
export const router = createBrowserRouter([
  {
    element: <BaseLayout />,
    // 첫 진입 시 페이지 청크를 받는 동안 그릴 것. 웹뷰 배경만 보이면 충분하다
    HydrateFallback: () => null,
    children: [
      {
        path: '/login',
        lazy: lazyPage(
          () => import(/* webpackChunkName: "page-login" */ 'pages/Login'),
        ),
      },
      {
        path: '/store-review-login',
        lazy: lazyPage(
          () =>
            import(
              /* webpackChunkName: "page-store-review-login" */ 'pages/StoreReviewLogin'
            ),
        ),
      },
      {
        path: '/signup/:type',
        lazy: lazyPage(
          () => import(/* webpackChunkName: "page-signup" */ 'pages/Signup'),
        ),
      },
      {
        path: '/contents/:id',
        lazy: lazyPage(
          () =>
            import(/* webpackChunkName: "page-contents" */ 'pages/Contents'),
        ),
      },
      {
        path: '/event/:id',
        lazy: lazyPage(
          () => import(/* webpackChunkName: "page-event" */ 'pages/Event'),
        ),
      },
      {
        path: '/event/:id/enroll-success',
        lazy: lazyPage(
          () =>
            import(
              /* webpackChunkName: "page-enroll-success" */ 'pages/EnrollSuccess'
            ),
        ),
      },
      {
        path: '/enroll',
        lazy: lazyPage(
          () =>
            import(
              /* webpackChunkName: "page-enroll-list" */ 'pages/EnrollList'
            ),
        ),
      },
      {
        path: '/enroll/:id',
        lazy: lazyPage(
          () => import(/* webpackChunkName: "page-enroll" */ 'pages/Enroll'),
        ),
      },
      {
        path: '/event/:id/feedback',
        lazy: lazyPage(
          () =>
            import(/* webpackChunkName: "page-feedback" */ 'pages/Feedback'),
        ),
      },
      {
        path: '/event/:id/schedule',
        lazy: lazyPage(
          () =>
            import(
              /* webpackChunkName: "page-event-schedule" */ 'pages/EventSchedule'
            ),
        ),
      },
      {
        path: '/event/:id/additional',
        lazy: lazyPage(
          () =>
            import(
              /* webpackChunkName: "page-additional" */ 'pages/Additional'
            ),
        ),
      },
      {
        path: '/welcome',
        lazy: lazyPage(
          () => import(/* webpackChunkName: "page-welcome" */ 'pages/Welcome'),
        ),
      },
      {
        path: '/faq',
        lazy: lazyPage(
          () => import(/* webpackChunkName: "page-faq" */ 'pages/Faq'),
        ),
      },
      {
        path: '/profile',
        lazy: lazyPage(
          () => import(/* webpackChunkName: "page-profile" */ 'pages/Profile'),
        ),
      },
      {
        path: '/profile/update',
        lazy: lazyPage(
          () =>
            import(
              /* webpackChunkName: "page-profile-update" */ 'pages/ProfileUpdate'
            ),
        ),
      },
      {
        path: '/signin',
        lazy: lazyPage(
          () => import(/* webpackChunkName: "page-signin" */ 'pages/Signin'),
        ),
      },
      {
        path: '/terms/:type',
        lazy: lazyPage(
          () => import(/* webpackChunkName: "page-terms" */ 'pages/Terms'),
        ),
      },
      {
        path: '/business-info',
        lazy: lazyPage(
          () =>
            import(
              /* webpackChunkName: "page-business-info" */ 'pages/BusinessInfo'
            ),
        ),
      },
      {
        path: '/badge',
        lazy: lazyPage(
          () => import(/* webpackChunkName: "page-badge" */ 'pages/Badge'),
        ),
      },
      {
        path: '/sticker',
        lazy: lazyPage(
          () => import(/* webpackChunkName: "page-sticker" */ 'pages/Sticker'),
        ),
      },
      {
        path: '/games',
        lazy: lazyPage(
          () =>
            import(/* webpackChunkName: "page-game-list" */ 'pages/GameList'),
        ),
      },
      {
        path: '/games/apple',
        lazy: lazyPage(
          () => import(/* webpackChunkName: "game-apple" */ 'pages/AppleGame'),
        ),
      },
      {
        path: '/games/sweet-potato',
        lazy: lazyPage(
          () =>
            import(
              /* webpackChunkName: "game-sweet-potato" */ 'pages/SweetPotatoGame'
            ),
        ),
      },
      {
        path: '/games/bread',
        lazy: lazyPage(
          () => import(/* webpackChunkName: "game-bread" */ 'pages/BreadGame'),
        ),
      },
      {
        path: '/games/andong-market',
        lazy: lazyPage(
          () =>
            import(
              /* webpackChunkName: "game-andong-market" */ 'pages/AndongMarketGame'
            ),
        ),
      },
      {
        path: '/games/briquette',
        lazy: lazyPage(
          () =>
            import(
              /* webpackChunkName: "game-briquette" */ 'pages/BriquetteGame'
            ),
        ),
      },
      {
        path: '/games/card-match',
        lazy: lazyPage(
          () =>
            import(
              /* webpackChunkName: "game-card-match" */ 'pages/CardMatchGame'
            ),
        ),
      },
      {
        path: '*',
        lazy: lazyPage(
          () =>
            import(/* webpackChunkName: "page-not-found" */ 'pages/NotFound'),
        ),
      },
    ],
  },
]);
